import 'css-chunksrc/client/pages/zonesPage/reportsPage/loader/reportLoader/indicatorsList/styles.scss';export default {
  "indicatorsList": "_indicatorsList_5r1bl_1",
  "input": "_input_5r1bl_10",
  "indicator": "_indicator_5r1bl_1",
  "name": "_name_5r1bl_28"
};